import { render, staticRenderFns } from "./signError.vue?vue&type=template&id=0f5e1565&scoped=true"
import script from "./signError.vue?vue&type=script&lang=js"
export * from "./signError.vue?vue&type=script&lang=js"
import style0 from "./signError.vue?vue&type=style&index=0&id=0f5e1565&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5e1565",
  null
  
)

export default component.exports